







































































































































































































import Vue from 'vue'
import { State, Action, Getter } from "vuex-class";
import { Component, Prop, Watch } from "vue-property-decorator";
import DateComponent from '@/components/common/Inputs/Date.vue';
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import { Utilities as utils } from "@/shared/utilities";
import { DetailExpense, IDetailExpense } from '@/entities/grants';
import { AppConstants as _app } from "@/shared/app.constants";
import { FinancialReportData } from "@/entities";
import DocumentRequestComponent from "./DocumentRequest.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "financialReport";

@Component({
    components: {
        DateComponent,
        FormattedNumber,
        DocumentRequestComponent,
        VCurrencyField
    }
})
export default class DetailedExpenseTable extends Vue {
    @State(namespace) financialReport!: FinancialReportData;

    @Prop() header: any;
    @Prop() items: Array<DetailExpense>;
    @Prop() currencyList: any;
    @Prop() grantInfo: any;
    @Prop() categories: any;
    @Prop() statement: any;
    @Prop() currency: string;
    @Prop() isFinalReport: boolean;
    @Prop() formOptions: any;
    @Prop() docItems: any;

    actions = _app.actions;
    subjects = _app.subjects;
    update = 0;
    searchString = '';
    includeFields = ["budgetCategory", "description"];
    pagination: any = {};
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    addRecord() {
        let newObj: DetailExpense = new DetailExpense({} as IDetailExpense);
        newObj.rowId =  utils.generateGUID();
        this.items.push(newObj);
        this.update += 1;
    }

    get minDate() {
        if (this.grantInfo && this.grantInfo.StartDate && this.grantInfo.AgreementDate) 
            return utils.getMinDate(this.grantInfo.AgreementDate, this.grantInfo.StartDate).split('T')[0];
    }
 
    get maxDate() {
        return new Date().toISOString().split('T')[0];
    }

    summary(key: any) {
        let sum = 0;
        if (this.items.length > 0) {
            this.items.map((row: any) => {
                sum += (row[key] || 0);
            });
        }
        return sum;
    }

    currencyFormat(val: any, format: any) {
        return utils.formatCurrency(val, format, this.defaultLocale);
    }

    deleteItem(item: DetailExpense) {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
        this.updateStatement(item.budgetCategory);
        this.update += 1;
    }
    /** calculate formulas */
    aggregate(item: DetailExpense) {
        if(item.amountInOriginalCurrency && item.exchangeRate){
            item.amountInEUR = utils.roundDecimal((item.amountInOriginalCurrency || 0) * (item.exchangeRate || 0));
        }
        else{
            item.amountInEUR = undefined;
        }  
        this.updateStatement(item.budgetCategory);   
    }

    /** update the statement */
    updateStatement(budgetLine: any) {
        if(this.statement){
            let exp = this.statement.summaryReport.find(x => x.categoryId == budgetLine);
            let oldVal: number = exp.currentExpenditure;
            exp.currentExpenditure = this.items.filter(x => x.budgetCategory == budgetLine).map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
            exp.totalExpenditure = exp.totalExpenditure + (exp.currentExpenditure - (oldVal || 0 ));
            exp.availableAmount = exp.amountBudgeted - exp.totalExpenditure;

            /** consolidation */
            // this.consolidation.expenditureSummary = this.items.filter(x => !x.isBankingCharges).map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
            // this.consolidation.bankCharges = this.items.filter(x => x.isBankingCharges).map(x => x.amountInEUR).reduce((a, b) => a + b || 0, 0);
            // this.consolidation.totalExpenditure = this.consolidation.expenditureSummary + this.consolidation.bankCharges
            // this.consolidation.totalCredited = ( (this.consolidation.balanceAtBeginning || 0) + (this.consolidation.fundInflow || 0) + (this.consolidation.creditInterest || 0) );
            // this.consolidation.balance = this.consolidation.totalCredited - (this.consolidation.totalExpenditure ?? 0);
            // this.consolidation.replenishAmount = this.consolidation.balance - (this.consolidation.forecast ?? 0);
        }
    }
    
      auditorHasPermission() {
    let hasPermission = false;

    hasPermission =
      //@ts-ignore
      this.$can(this.actions.update, this.subjects.finReportAudit) &&
      this.financialReport.selectedReport.WorkFlowStatusId ==
        _app.finReportAuditStatus.readyForAudit &&
      this.financialReport.selectedReport.WorkflowInfo.CurrentStep
        .ReturnStatus == 0;

    return hasPermission;
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 46
    ) {
      evt.preventDefault();
    } else {
      return true;
    }
  }
  
  setExchRate(item) {
    if (this.currencyList.find(x => x.Value == item.currency).DisplayText == this.currency){
      item.exchangeRate = 1;
    }
    else{
        item.exchangeRate = undefined;
    }
  }

  getFeedbackHeader(rowKey) {
        if (this.formOptions && this.formOptions.feedbacks) {
        return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
        } else {
            return null;
        }
  }

  fileDownload(item){
        const selectedDoc = this.docItems.find(doc => doc.name === item.mappedFileName);
        this.$services.document.download(selectedDoc);
  }

}
